<template>
    <div>
        <navbar :hide_search="true" back_path="/ticket-system-report" active_screen="แจ้งปัญหาการใช้งาน" />
        <div class="ml-mr-mb-20">
            <div class="br-20" style="background-color: #fff">
                <div class="p-20">
                    <a-form :form="form" layout="vertical">
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('ประเภทเรื่องหลัก') }}</span>
                                <span class="fs-18 fw-600 red"> *</span>
                                <a-select class="fs-16 fw-600 black" :placeholder="$t('กรุณาเลือกประเภทหลัก')" v-decorator="['ticket_type_level0', { rules: [{ required: true, message: 'กรุณาเลือกประเภทหลัก' }] }]" @change="handleSelectTypeLevel0">
                                    <a-select-option class="black" :value="v.name" v-for="(v, k) in type_level0" :key="k"> {{ v.name }} </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('ประเภทเรื่องย่อย') }}</span>
                                <span class="fs-18 fw-600 red"> *</span>
                                <a-select class="fs-16 fw-600 black" :placeholder="$t('กรุณาเลือกประเภทรอง')" v-decorator="['ticket_type_level1', { rules: [{ required: true, message: 'กรุณาเลือกประเภทรอง' }] }]" @change="handleSelectTypeLevel1">
                                    <a-select-option class="black" :value="v.name" v-for="(v, k) in type_level1" :key="k"> {{ v.name }} </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('ชื่อเรื่อง') }}</span>
                                <span class="fs-18 fw-600 red"> *</span>
                                <a-select class="fs-16 fw-600 black" :placeholder="$t('กรุณาเลือกเรื่อง')" v-decorator="['ticket_type_level2', { rules: [{ required: true, message: 'กรุณาเลือกเรื่อง' }] }]" @change="handleSelectTypeLevel2">
                                    <a-select-option class="black" :value="v.name" v-for="(v, k) in type_level2" :key="k"> {{ v.name }} </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('วันที่เจอปัญหา') }}</span>
                                <span class="fs-13 fw-600 black"> {{ $t('(โดยประมาณ)') }}</span>
                                <a-date-picker class="w-100" :placeholder="$t('กรุณาเลือกวัน')" v-decorator="['problem_date', { initialValue: null }]" :format="problemDateFormat" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" :show-second="false" />
                            </a-form-item>
                        </div>
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('รายละเอียด') }}</span>
                                <span class="fs-18 fw-600 red"> *</span>
                                <a-textarea :placeholder="$t('กรุณาระบุคำบรรยาย')" v-decorator="['detail', { rules: [{ required: true, message: 'กรุณาระบุคำบรรยาย' }] }]" :auto-size="{ minRows: 4, maxRows: 4 }" />
                            </a-form-item>
                        </div>
                        <div class="row">
                            <a-form-item class="w-100">
                                <span class="fs-18 fw-600 black">{{ $t('ภาพประกอบ') }}</span>
                                <span class="fs-18 fw-600 red" v-if="require_pic"> *</span>
                                <span class="fs-13 fw-600 black" v-else> {{ $t('(ถ้ามี)') }}</span>
                                <div class="clickable">
                                    <a-upload :showUploadList="false" @change="handleUploadImage">
                                        <img :src="uploadedImage" />
                                    </a-upload>
                                </div>
                            </a-form-item>
                        </div>
                        <div class="row text-center">
                            <div class="col-6">
                                <a-button size="large" class="text-center default-btn br-20 w-90 mr-8" @click="$router.replace({ path: '/ticket-system-report' })">
                                    <span class="fs-18 color-red"> {{ $t('ยกเลิก') }}</span>
                                </a-button>
                            </div>
                            <div class="col-6">
                                <a-button size="large" class="text-center bg-red br-20 w-90 ml-8" @click="onSave()">
                                    <span class="fs-18 color-white"> {{ $t('ยืนยัน') }}</span>
                                </a-button>
                            </div>
                        </div>
                    </a-form>
                </div>
            </div>
        </div>
        <modal-form :visible="modal_visible" :step="modal_step" :data="modal_data" @on-cancel="onModalCancel" @on-confirm="onModalConfirm" />
    </div>
</template>
<script>
import navbar from '../../components/navbar';
import _ from 'lodash';
import moment from 'moment';
import modalForm from './modalForm';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            form: this.$form.createForm(this),
            type_level0: [],
            type_level1: [],
            type_level2: [],
            problemDateFormat: 'LL | HH.mm',
            uploadedImage: require('../../../public/resources/images/ticket-system-report/upload-image.png'),
            attach_file: null,
            modal_visible: false,
            modal_step: null,
            modal_data: {},
            require_pic: false,
        };
    },
    mounted() {
        this.getTypeLevel0();
    },
    methods: {
        getTypeLevel0: _.debounce(function () {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/problemTicket/type_level0',
                    data: {},
                    callback: (res) => {
                        if (res && res.result == 'complete') this.type_level0 = res.data;
                    },
                },
            });
        }, 250),
        handleSelectTypeLevel0: _.debounce(function (parent) {
            _.each(this.type_level0, (v) => {
                if (v.name == parent) this.require_pic = v.require_pic == 1;
            });

            this.form.resetFields(['ticket_type_level1', 'ticket_type_level2']);
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/problemTicket/type_level1',
                    data: { parent },
                    callback: (res) => {
                        if (res && res.result == 'complete') this.type_level1 = res.data;
                    },
                },
            });
        }, 250),
        handleSelectTypeLevel1: _.debounce(function (parent) {
            if (parent == 'ข้อมูลวันเกิด' || parent == 'ข้อมูลเบอร์โทรศัพท์มือถือ') {
                this.modal_step = 'other';
                this.modal_data.title = 'แจ้งเตือน';
                this.modal_data.message = 'โปรดอัปโหลดสำเนาบัตรประชาชนเพื่อยืนยันตัวตน';
                this.modal_visible = true;
            }
            this.form.resetFields(['ticket_type_level2']);
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/problemTicket/type_level2',
                    data: { parent },
                    callback: (res) => {
                        if (res && res.result == 'complete') this.type_level2 = res.data;
                    },
                },
            });
        }, 250),
        handleSelectTypeLevel2: _.debounce(function (parent) {
            if (parent == 'พบปัญหาการใช้งานบัตร') {
                this.modal_step = 'other';
                this.modal_data.title = 'แจ้งเตือน';
                this.modal_data.message = 'โปรดอัปโหลดเอกสารที่เกี่ยวข้อง เช่น สลิป, ใบเสร็จ การเติมน้ำมัน';
                this.modal_visible = true;
            }
        }, 250),
        getBase64(img, callback) {
            const reader = new FileReader();
            reader.addEventListener('load', () => callback(reader.result));
            reader.readAsDataURL(img);
        },
        async handleUploadImage({ fileList }) {
            const file = _.get(fileList, '0');
            if (file && file.originFileObj) {
                this.attach_file = file.originFileObj;
                this.getBase64(file.originFileObj, (imageUrl) => (this.uploadedImage = imageUrl));
            }
        },
        onSave() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    const formData = new FormData();
                    if (_.size(_.get(values, 'ticket_type_level0'))) formData.append('ticket_type_level0', values.ticket_type_level0);
                    if (_.size(_.get(values, 'ticket_type_level1'))) formData.append('ticket_type_level1', values.ticket_type_level1);
                    if (_.size(_.get(values, 'ticket_type_level2'))) formData.append('ticket_type_level2', values.ticket_type_level2);
                    if (_.size(_.get(values, 'detail'))) formData.append('detail', values.detail);
                    if (_.size(_.get(values, 'problem_date'))) formData.append('problem_date', moment(values.problem_date).format('YYYY-MM-DD HH:mm'));
                    if (_.size(_.get(this, 'attach_file'))) formData.append('attach_file', this.attach_file);
                    this.$store.dispatch('user/POST', {
                        payload: {
                            path: '/api/problemTicket/create',
                            data: formData,
                            callback: (res) => {
                                if (_.get(res, 'result') == 'complete') {
                                    this.modal_step = 'success';
                                    this.modal_data.title = _.get(res, 'complete.title.0', '' /* 'แจ้งปัญหาการใช้งานสำเร็จ' */);
                                    this.modal_data.message = _.get(res, 'complete.msg.0', '' /* 'ระบบได้รับแจ้งปัญหาของท่านแล้ว สามารถติดตามสถานะได้ที่เมนู "แจ้งปัญหาการใช้งาน"' */);
                                    this.modal_visible = true;
                                } else if (_.size(_.get(res, 'errors'))) {
                                    this.modal_step = 'fail';
                                    this.modal_data.title = _.get(res, 'errors.title.0', '' /* 'แจ้งปัญหาการใช้งานไม่ได้' */);
                                    this.modal_data.message = _.get(res, 'errors.msg.0', '' /* 'ไม่สามารถส่งเรื่องไปยังเจ้าหน้าที่ที่เกี่ยวข้องได้ กรุณาลองใหม่อีกครั้ง' */);
                                    this.modal_visible = true;
                                }
                            },
                        },
                    });
                }
            });
        },
        onModalCancel() {
            this.modal_visible = false;
            this.modal_step = null;
            this.modal_data = {};
        },
        onModalConfirm() {
            this.$router.replace({ path: '/ticket-system-report' });
        },
        moment,
    },
};
</script>
<style scoped>
</style>